import React from "react";
import TextEditor from "../../components/TextEditor";
import Header from "../../components/Header/Header";
import SideBar from "../../components/SideBar/AdminSideBar";
import { Link } from "react-router-dom";
import { hooks } from "../../studentportal-sdk";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { addCourseSchema, editCourseSchema } from "../../constant";
import { useState } from "react";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";

const EditCourse = (props) => {
  const {
    courseService: {
      store: { courseId, courseDoc },
      action: { updateCourse },
    },
  } = props;

  // const id = history.location.pathname.split('/')[2]
  const [course, setCourse] = useState({
    courseId,
    title: "",
    description: "",
    startDate: "",
    endDate: "",
  });

  const convertDescription = (htmlDescription) => {
    return htmlDescription.replace(/<\/?[^>]+(>|$)/g, "");
  };
  const handleEditorChange = (data) => {
    setCourse({
      ...course,
      description: convertDescription(data), // Update the course description with editor data
    });
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editCourseSchema),
  });

  const onSubmit = (data) => {
    if (data) {
      setCourse({ ...course, ...data });
      updateCourse(course);
    }
    // userAccountSignUp(data);
  };

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />
        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12">
                {/* Page Header */}
                <div className="page-header">
                  <Link to="/courses" className="back-btn">
                    <i className="feather-chevron-left">
                      <FeatherIcon icon="chevron-left" />
                      Back
                    </i>
                  </Link>
                  <div className="row">
                    <div className="col-sm-12">
                      <h3 className="page-title">Edit Course</h3>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <form className="card" onSubmit={handleSubmit(onSubmit)}>
                  <div className="card-body">
                    <div className="bank-inner-details">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>
                              Title<span className="text-danger">*</span>
                            </label>
                            <Controller
                              name="title"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <input
                                    className={`form-control  ${
                                      errors?.title ? "error-input" : ""
                                    }`}
                                    type="text"
                                    value={value}
                                    onChange={onChange}
                                    autoComplete="false"
                                    placeholder={courseDoc?.title}
                                  />
                                </>
                              )}
                              defaultValue={courseDoc?.title}
                            />
                            <small>{errors?.title?.message}</small>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>Course Image</label>
                            <div className="change-photo-btn">
                              <div>
                                <p>Upload File</p>
                              </div>
                              <input type="file" className="upload" />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <label>Description</label>
                            <TextEditor onChange={handleEditorChange} />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Start Date</label>
                            <Controller
                              name="startDate"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <input
                                    type="date"
                                    className={`form-control  ${
                                      errors?.startDate ? "error-input" : ""
                                    }`}
                                    onChange={onChange}
                                    placeholder={courseDoc?.startDate}
                                  />
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.startDate?.message}</small>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>End Date</label>
                            <Controller
                              name="endDate"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <input
                                    type="date"
                                    className={`form-control  ${
                                      errors?.endDate ? "error-input" : ""
                                    }`}
                                    onChange={onChange}
                                    placeholder={courseDoc?.endDate}
                                  />
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.endDate?.message}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" blog-categories-btn pt-0 ">
                    <div className="bank-details-btn ">
                      <button
                        type="submit"
                        style={{ marginTop: "12px" }}
                        className="btn btn-primary"
                      >
                        Save Course
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* /Page Wrapper */}
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default (props) => <EditCourse {...hooks.course(props)} />;
